import { FieldDefinition, FieldBuilder, MenuCategories, MenuSubcategories, MENU_CATEGORY_KEY, MENU_SUBCATEGORY_KEY, MENU_NAME_SUFFIX } from '@zendra/shared';

import { ContractTypeService } from '../proxy/controlling/controllers/contract-type.service';
import { LocationService } from '@planning/proxy/planning/controllers/location.service';
import { ForecastService } from '../proxy/controlling/controllers/forecast.service';
FieldBuilder.setNamespace('Controlling');

export const CONTRACTTYPEFORECAST_FIELDS: FieldDefinition[] = [
  FieldBuilder.foreignKey('contractTypeId', 'Entity.ContractType', ContractTypeService)
    .displayFromNested('contractType.name')
    .sortBy('contractType.name')
    .hideInChildForms()
    .build(),
  FieldBuilder.foreignKey('regionLocationId', 'Entity.ContractTypeForecast.RegionLocation', LocationService)
    .queryFilter({ locationTypeEntityName: 'Region' })
    .display('name')
    .keyField('id')
    .build(),
  FieldBuilder.foreignKey('forecastId', 'Entity.Forecast', ForecastService)
    .displayFromNested('forecast.name')
    .sortBy('forecast.name')
    .build(),
];

export const CONTRACTTYPEFORECAST_CONFIG = {
  entityName: 'ContractTypeForecast',
  localizationKey: 'Controlling::Entity.ContractTypeForecast',
  fields: CONTRACTTYPEFORECAST_FIELDS,
  permission: 'Controlling.ContractTypeForecasts',
  showInMenu: true,
  menuCategory: MENU_CATEGORY_KEY + MenuCategories.Controlling + MENU_NAME_SUFFIX,
  menuSubcategory: MENU_SUBCATEGORY_KEY + MenuSubcategories.Contracts + MENU_NAME_SUFFIX,
};
